export enum L2SideNavType {
    None,
    Detectors,
    Develop_Detectors,
    Gits,
}

export const l2SideNavWidth = 310;